// Badge de estado de facturación: 🧾 Facturado (verde) / ⚠️ Sin facturar (rojo).
// Se usa en las cards de pedidos despachados (ventas y encargado).
import React from "react";

export default function FacturadoBadge({ facturado, size = "sm" }) {
  const ok = facturado === true;
  const lg = size === "lg";
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: "4px",
      fontSize: lg ? "0.8rem" : "0.64rem", fontWeight: 700,
      padding: lg ? "3px 10px" : "2px 7px", borderRadius: "999px",
      background: ok ? "#f0fdf4" : "#fef2f2",
      color: ok ? "#15803d" : "#b91c1c",
      border: `1px solid ${ok ? "#86efac" : "#fecaca"}`,
      whiteSpace: "nowrap", flexShrink: 0,
    }}>
      {ok ? "🧾 Facturado" : "⚠️ Sin facturar"}
    </span>
  );
}
